<div class="component">
  <div class="button-go-back">
    <button class="btn-goback" (click)="goback()">Voltar</button>
  </div>
  <div class="mat-elevation-z4">
    <table mat-table [dataSource]= "dataSource">

        <!-- Name Column -->
        <ng-container matColumnDef="nome">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let cliente">{{cliente.nome | titlecase}}</td>
        </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="telefone" >
        <th mat-header-cell *matHeaderCellDef>Telefone</th>
        <td mat-cell *matCellDef="let cliente">{{cliente.telefone | telefonePipe }}</td>
      </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="cpf" >
        <th mat-header-cell *matHeaderCellDef>CPF </th>
        <td mat-cell *matCellDef="let cliente">{{cliente.cpf | cpf}}</td>

      </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="email" >
        <th mat-header-cell *matHeaderCellDef>E-mail </th>
        <td mat-cell *matCellDef="let cliente">{{cliente.email | uppercase}}</td>
      </ng-container>

      <!-- Action Column -->
      <ng-container matColumnDef="acoes" >
        <th mat-header-cell *matHeaderCellDef >Ações</th>
        <td mat-cell *matCellDef="let cliente" >{{cliente.acoes}}
          <a class="edit" (click)="editar(cliente)">
            <i class="material-icons">edit</i>
          </a>

          <a class="delete" routerLink="" (click)="remover(cliente)">
            <i class="material-icons ">delete_outline</i>
          </a>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef=" mostrarColunas"></tr>
      <tr mat-row *matRowDef="let row; columns:  mostrarColunas;"></tr>
      </table>
  </div>
  </div>
